<template>
 <div>
    <div class="row " >
    <div class="verticalLine">
    <div class="list-group " id="list-tab" role="tablist">
    <div>
        <SearchAutoComplete :isAsync="true"></SearchAutoComplete>
    </div>
    <div v-if="!$store.state.showMw">
    <div class="list-group-item list-group-item-action sidepane "  v-for="mw in $store.state.marketWatch " v-bind:key="mw.instrumentToken"  id="list-home-list"  >
        <div class="row ">
        <span class="col-sm-9 col-md-9 wordwrap">{{ mw.displayName }} </span>
        <span class = "col-sm-3 col-md-3 " >{{ $store.state.ticker[mw.instrumentToken]}}</span>
        <div >
        <button  type="button" @click="openBuySell('BUY', mw)" class="btn btn-xs buttonStyle">B</button>
        <button  type="button" @click="openBuySell('SELL', mw)" class="btn  btn-xs  buttonStyle">S</button>
        <button  type="button" @click="openChart( mw)" class="btn  btn-xs  buttonStyle"><i class="bi bi-graph-up-arrow"></i></button>
        <button  type="button" class="btn   btn-xs  buttonStyle" @click="handleDelete(mw.instrumentToken)"><i class="bi bi-trash "></i></button>
        </div>
        </div>
    </div>
  </div>
    </div>
    </div>
    </div>
 </div>
</template>

<script>
import { getMarketWatch, deleteMarketWatch } from '@/service/restService'
import SearchAutoComplete from '@/components/marketwatch/SearchAutoComplete'
export default {
  name: 'MarketWatch',
  components: {
    SearchAutoComplete
  },
  methods: {
    getMarketWatch: function () {
      if (this.$store.state.orderFirstTimeFlag) {
        getMarketWatch().then((response) => {
          this.$store.commit('updateMarketWatch', response.data)
          this.$store.commit('disableMwFirstTime')
        }).catch((error) => {
          this.$store.commit('addToast', {
            title: 'Failure!',
            type: 'error',
            message: error.response.data.message[0]
          })
        })
      }
    },
    handleDelete: function (scriptId) {
      deleteMarketWatch(scriptId).then((response) => {
        this.$store.commit('removeMyScripts', response.data.instrumentToken)
        this.$store.commit('removeMyMarketWatch', response.data.instrumentToken)
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    },
    openBuySell: function (type, mw) {
      this.$store.commit('setBuySell', {'type': type, 'mw': mw})
    },
    openChart: function (id) {
      this.$store.commit('setchartMw', id)
      this.$router.push('/chart')
    }
  },
  created () {
    this.getMarketWatch()
  }
}

</script>

<style scoped>
.verticalLine {
  border-right: 2px solid var(--bs-border-color);
  height:40em;

}
.wordwrap {
  word-wrap: break-word;
}
.sidepane:hover .buttonStyle{
  display: inline;
  float: none;
}

.buttonStyle {
  margin: 1px;
  display: none;
  align-items: center;
  padding: 1px;
  border: 1px solid var(--bs-border-color);
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  font-weight: bold;
  width:  30px;
  height: 30px;
}

.buttonStyle:hover {
  background-color: var(--bs-tertiary-bg);
}

.sidepane {border-color: var(--bs-border-color);}
</style>



// WEBPACK FOOTER //
// src/components/marketwatch/MarketWatch.vue